export const recommendationsEntityKeyBuilder = (
  panelName: string,
  productCode?: string | number,
  articleCode?: string | number
): string => `${panelName}|${productCode || 'no-product'}|${articleCode || 'no-article'}`;
